// extracted by mini-css-extract-plugin
module.exports = {"container":"Header_container__2Dw3O","logo":"Header_logo__24o6g"};